import React from 'react';
import styled from 'styled-components';
import { FaArrowRight } from 'react-icons/fa6';

const Button = ({ className }) => {
  return (
    <StyledWrapper className={className}>
      <button className="button">
        <div className="button-box">
          <span className="button-elem">
            <FaArrowRight style={{ width: '20px', height: '20px', color: 'white' }} />
          </span>
          <span className="button-elem">
            <FaArrowRight style={{ width: '20px', height: '20px', color: 'white' }} />
          </span>
        </div>
      </button>
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  .button {
    display: block;
    position: relative;
    width: 56px;
    height: 56px;
    margin: 0;
    overflow: hidden;
    outline: none;
    background-color: transparent;
    cursor: pointer;
    border: 0;
  }

  .button:before,
  .button:after {
    content: '';
    position: absolute;
    border-radius: 50%;
    inset: 7px;
  }

  .button:before {
    border: 2px solid #f0eeef;
    transition: opacity 0.4s cubic-bezier(0.77, 0, 0.175, 1) 80ms,
      transform 0.5s cubic-bezier(0.455, 0.03, 0.515, 0.955) 80ms;
  }

  .button:after {
    border: 2px solid #d40d14d7;
    transform: scale(1.3);
    transition: opacity 0.4s cubic-bezier(0.165, 0.84, 0.44, 1),
      transform 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    opacity: 0;
  }

  &.hovered .button:before {
    opacity: 0;
    transform: scale(0.7);
    transition: opacity 0.4s cubic-bezier(0.165, 0.84, 0.44, 1),
      transform 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }

  &.hovered .button:after {
    opacity: 1;
    transform: scale(1);
    transition: opacity 0.4s cubic-bezier(0.77, 0, 0.175, 1) 80ms,
      transform 0.5s cubic-bezier(0.455, 0.03, 0.515, 0.955) 80ms;
  }

  .button-box {
    display: flex;
    position: absolute;
    top: 0;
    right: 0;
  }

  .button-elem {
    display: block;
    width: 20px;
    height: 20px;
    margin: 17px 18px 0 18px;
    fill: #f0eeef;
  }

  &.hovered .button-box {
    transition: 0.4s;
    transform: translateX(56px);
  }
`;

export default Button;
